<div class="modal-header main-modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
        (click)="closeModal()">×</button>
    <h4 class="modal-title wrap-text-in">
        <span>{{title}}</span>
    </h4>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-xs-12">
            <app-delete-assessment-credential context="{{context}}"
                [companyId]="companyId"
                [buId]="buId"
                [testOwnerEmail]="testOwnerEmail"
                [assessmentId]="assessmentId"
                [isDeleteCredential]="isDeleteCredential"
                (successCallback)="delete()"
                (cancelCallback)="closeModal()">
            </app-delete-assessment-credential>
        </div>
    </div>
</div>
